import AppDispatcher from '../dispatcher/AppDispatcher'
import TransportConstants from '../constants/TransportConstants'
import { EventEmitter } from 'events'

const CHANGE_EVENT = 'change'
const month_names = {
  1: 'Styczeń',
  2: 'Luty',
  3: 'Marzec',
  4: 'Kwiecień',
  5: 'Maj',
  6: 'Czerwiec',
  7: 'Lipiec',
  8: 'Sierpień',
  9: 'Wrzesień',
  10: 'Październik',
  11: 'Listopad',
  12: 'Grudzień'
}

function compare_months(a,b) {
  if (a.year < b.year)
    return -1;
  if (a.year > b.year)
    return 1;
  return a.month - b.month
}

let _month = []
let _months = []

function setTransports(month) {
  month.name = month_names[month.month] + ' ' + month.year
  _month = month
}

function setMonths(months) {
  months.map(month => {
    month.name = month_names[month.month] + ' ' + month.year
  })
  months.sort(compare_months)
  _months = months;
}

class TransportStoreClass extends EventEmitter {

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback)
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback)
  }

  getTransports() {
    return _month;
  }

  getMonths() {
    return _months;
  }

}

const TransportStore = new TransportStoreClass();

TransportStore.dispatchToken = AppDispatcher.register(action => {

  switch(action.actionType) {
    case TransportConstants.RECIEVE_MONTHS:
      setMonths(action.months)
      TransportStore.emitChange()
      break

    case TransportConstants.RECIEVE_TRANSPORTS:
      setTransports(action.month)
      TransportStore.emitChange()
      break

    case TransportConstants.RECIEVE_TRANSPORTS_ERROR:
      alert(action.message)
      TransportStore.emitChange()
      break

    case TransportConstants.RECIEVE_MONTHS_ERROR:
      alert(action.message)
      TransportStore.emitChange()
      break

    default:
  }

});

export default TransportStore;



// WEBPACK FOOTER //
// ./src/stores/TransportStore.js